<template>
  <div class="row">
    <div class="col-md-4" v-for="(item, index) in serviceCard" :key="index">
      <div class="service-cards cases">
        <div class="img-wrapper">
          <img :src="item.image" alt="card-image">
        </div>
        <div class="content-wrapper">
          <!-- Dynamic Translations for Title and Text -->
          <h2 class="h2" v-html="$t(item.title)"></h2>
          <p v-html="$t(item.text)"></p>
        </div>
        <div class="btn-wrapper">
          <Router-link :to="item.btnlink" class="btn-style">{{ $t('cases.readMore') }}</Router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesCard',
  data() {
    return {
      serviceCard: [
        {
          image: require('@/assets/images/warehouse.jpg'),
          title: 'cases.transport.title',
          text: 'cases.transport.text',
          btnlink: '/cases/logistiek',
        },
        {
          image: require('@/assets/images/milling.jpg'),
          title: 'cases.metalworking.title',
          text: 'cases.metalworking.text',
          btnlink: '/cases/metaalbewerking',
        },
        {
          image: require('@/assets/images/ai-card.jpg'),
          title: 'cases.ai.title',
          text: 'cases.ai.text',
          btnlink: '/cases/ai',
        },
      ],
    };
  },
};
</script>
